import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.jsx'
import KeyGuard from '@components/KeyGuard/KeyGuard.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <KeyGuard>
        <App />
      </KeyGuard>
    </HelmetProvider>
  </StrictMode>,
)
